import React from 'react'
import {Container} from 'react-bootstrap'
import {Link} from 'react-router-dom'
import './style.css'

export default function transaksi() {
    return (
          <>
             {
                Transaksi.map((item, i) => {
                    return (
                       <Container key={i} className="comp-transaksi">
                           <Link to={item.link} className={item.cls}>
                                <p>{item.text}</p>
                                <img src="asset/users/right.svg" alt="img-dropdown" />
                           </Link>
                       </Container>
                    )
                })
             }
          </>
    )
}

const Transaksi = [
    {text:"Statistik Transaksi", link:"statistik", cls:"link-transaksi"},
    {text:"Transaksi Malmora", link:"transaksi", cls:"link-transaksi"},
    {text:"Transaksi Berberkah", link:"transaksi_ber", cls:"link-transaksi"},
    {text:"Nomor Rekening Terdaftar", link:"rekening", cls:"link-transaksi"},
    {text:"Riwayat Pembayaran", link:"riwayat"}
]
